/**
 * OOXML measurement units.
 *
 * EMU (English Metric Unit) is the universal length unit in DrawingML:
 * 914400 EMU = 1 inch = 72 points = 96 CSS pixels at 1x.
 */

/** English Metric Units. 914400 per inch. */
export type Emu = number;

/** Hundredths of a point, used by `sz` on text runs (`sz="1800"` = 18pt). */
export type Centipoint = number;

/** 60000ths of a degree, used by `rot` on transforms (`rot="5400000"` = 90deg). */
export type SixtyThousandthsDegree = number;

/** Thousandths of a percent, used by colour transforms (`val="50000"` = 50%). */
export type Milliperecent = number;

export const EMU_PER_INCH = 914400;
export const EMU_PER_POINT = 12700;
export const EMU_PER_PIXEL = 9525;
export const POINTS_PER_INCH = 72;

export function emuToPoints(emu: Emu): number {
  return emu / EMU_PER_POINT;
}

export function emuToPixels(emu: Emu): number {
  return emu / EMU_PER_PIXEL;
}

export function pointsToEmu(points: number): Emu {
  return Math.round(points * EMU_PER_POINT);
}

export function centipointsToPoints(cp: Centipoint): number {
  return cp / 100;
}

export function angleToDegrees(rot: SixtyThousandthsDegree): number {
  return rot / 60000;
}

/** OOXML expresses many percentages as thousandths: `50000` means 50%. */
export function milliPercentToFraction(v: Milliperecent): number {
  return v / 100000;
}
